import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import {
  branch,
  compose,
  lifecycle,
  renderComponent,
  withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'

import { RBAC_FLOWS } from 'constants/flowConstants'
import { uploadFile } from 'modules/file/api'
import * as actions from 'modules/profile/actions'
import * as RoutingSelectors from 'modules/routing/selectors'
import * as UserActions from 'modules/user/actions'
import { api } from 'modules/user/api'
import * as UserSelectors from 'modules/user/selectors'
import { getRoot } from 'modules/user/selectors'
import { page, track } from 'utils/trackingUtils'

import {
  AEProfilePhotoStep,
  BasicProfileStep,
  ProfilePhotoStep,
} from './component'

const hasSalesRole = (workspaceRoles) =>
  workspaceRoles
    .map((wsRole) => wsRole.role)
    .some(
      (role) =>
        role.isGlobal &&
        (role.name === 'Sales Rep' || role.name === 'Sales Manager')
    )

const mapStateToProps = (state) => ({
  user: getRoot(state),
  profile: state.profile,
  name: UserSelectors.getName(state),
  stagedProfilePicture: UserSelectors.getProfilePicture(state),
  isRepInvitedFlow: UserSelectors.isRepInvitedFlow(state),
  isServiceAgentFlow: UserSelectors.isServiceAgentFlow(state),
  isSSOProvisionedFlow: UserSelectors.isSSOProvisionedFlow(state),
  avatarUrl: UserSelectors.getAvatarUrl(state),
  flow: UserSelectors.getFlow(state),
  nextPath: RoutingSelectors.getNextPath(state),
  hasSocialInvite: UserSelectors.getHasSocialInvite(state),
  userRoles: UserSelectors.getUserRoles(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      uploadCoverPhoto: actions.uploadCoverPhoto,
      createProfile: actions.createProfile,
      setName: UserActions.setName,
      updateUser: UserActions.updateUser,
      stageProfilePicture: UserActions.stageProfilePicture,
      setAvatarUrl: UserActions.setAvatarUrl,
      push,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Profile Name and Photo Setup', {
        flow: this.props.flow,
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
      })
    },
  }),
  withHandlers({
    onDrop: (props) => (files) => {
      const file = files[0]
      if (props.hasSocialInvite) {
        props.actions.stageProfilePicture(file)
        uploadFile(files[0]).then((response) => {
          const newFileUrl = response.downloadUrl
          props.actions.setAvatarUrl(newFileUrl)
        })
      } else if (props.isCalendarSeat) {
        uploadFile(files[0]).then((response) => {
          const newFileUrl = response.downloadUrl
          props.actions.setAvatarUrl(newFileUrl)
        })
      } else {
        props.isRepInvitedFlow
          ? props.actions.stageProfilePicture(file)
          : props.actions.uploadCoverPhoto(file)
      }
    },
    onClearAvatar: (props) => () => {
      props.actions.stageProfilePicture(null)
      props.avatarUrl && props.actions.setAvatarUrl(null) // clear the avatar url if its on the user
    },
    onContinueClick: (props) => () => {
      track('Onboarding Profile Name and Photo Setup Completed', {
        context: props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
        skipped: false,
      })

      if (props.hasSocialInvite || props.isCalendarSeat) {
        api
          .setName(props.user.userId, {
            name: props.user.name,
            avatarUrl: props.avatarUrl,
          })
          .then(() => props.actions.createProfile())
      } else {
        !props.isRepInvitedFlow &&
          api
            .setName(props.user.userId, { name: props.user.name })
            .then(() => props.actions.createProfile())
      }

      if (props.hasSocialInvite) {
        if (hasSalesRole(props.userRoles)) {
          props.actions.push('/invite/notifications')
        } else {
          props.actions.push('/invite/personalize')
        }
      } else if (props.isCalendarSeat) {
        props.actions.push('/setup/calendaring/connect')
      } else if (props.isSSOProvisionedFlow) {
        props.actions.push('/setup/meetings')
      } else if (RBAC_FLOWS.indexOf(props.flow) > -1) {
        props.actions.push(props.nextPath)
      } else if (props.isRepInvitedFlow) {
        props.actions.push('/setup/password')
      } else {
        props.actions.push('/setup/profile/color')
      }
    },
    onNameChange: (props) => (event) => {
      props.actions.setName(event.target.value)
    },
  }),
  branch((props) => props.isEnterpriseSeat, renderComponent(BasicProfileStep)),
  branch((props) => props.isCalendarSeat, renderComponent(AEProfilePhotoStep))
)(ProfilePhotoStep)
